import { BefehlsnachrichtDto } from '@/apis/dtos/befehlsnachricht-dto'
import { Befehlsnachricht, BfnStatus } from '@/models/Befehlsnachricht'
import { convertStandortDtoToModel } from '@repo/ui'
import { convertBefehlDtoToModel } from './befehl-dto-converter'

export async function convertBefehlsnachrichtDtoToModel(
  dto: BefehlsnachrichtDto
): Promise<Befehlsnachricht> {
  return {
    id: dto.id,
    zugnummer: dto.zugnummer,
    artDerFahrt: dto.artDerFahrt,
    eindeutigeKennung: dto.eindeutigeKennung,
    status: dto.status,
    visuellerStatus: dto.visuellerStatus,
    statusTimestamps: dto.statusTimestamps.map(
      (statusTimestamp: {
        status: BfnStatus
        time: string
        visuellerStatus: string
      }) => {
        return {
          ...statusTimestamp,
          time: new Date(statusTimestamp.time)
        }
      }
    ),
    fdlName: dto.fdlName,
    fdlArbeitsplatz: dto.fdlArbeitsplatz,
    fdlArbeitsplatzOrt: dto.fdlArbeitsplatzOrt,
    versandzeitpunkt: new Date(dto.versandzeitpunkt),
    bearbeitbarBis: new Date(dto.bearbeitbarBis),
    quittierungsdatum: dto.quittierungsdatum
      ? new Date(dto.quittierungsdatum)
      : null,
    standort: dto.standort ? convertStandortDtoToModel(dto.standort) : null,
    befehle: await Promise.all(
      dto.befehle.map((befehl, index) =>
        convertBefehlDtoToModel(befehl, dto.id, index)
      )
    ),
    hash1: dto.hash1,
    hash2: dto.hash2,
    eindeutigeKennungHash: dto.eindeutigeKennungHash,
    statusTfHash: dto.statusTfHash,
    standortHash: dto.standortHash
  }
}
